import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tên danh mục vật tư:")
], -1)
const _hoisted_8 = { class: "col-4 d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Mã danh mục:")
], -1)
const _hoisted_12 = { class: "col-4 d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mô tả:")
], -1)
const _hoisted_17 = { class: "col-4 d-flex align-items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Danh mục cha:")
], -1)
const _hoisted_21 = { class: "col-4 d-flex align-items-center" }
const _hoisted_22 = { class: "mt-5 row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-10" }, null, -1)
const _hoisted_24 = { class: "col-2 d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_TaiKhoanSelection = _resolveComponent("TaiKhoanSelection")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.isCreating ? "Tạo mới" : "Chỉnh sửa"), 1)
      ]),
      _createVNode(_component_ButtonCustom, {
        "color-type": _ctx.ButtonTypeColors.PRIMARY,
        "button-type": _ctx.ButtonsType.BACK,
        onClick: _ctx.goBack
      }, null, 8, ["color-type", "button-type", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        class: "form",
        model: _ctx.danhMucVatTuFormValue,
        rules: _ctx.rules,
        onSubmit: _withModifiers(_ctx.submit, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_form_item, {
                prop: "ten_danh_muc",
                class: "mb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "tên danh mục",
                    modelValue: _ctx.danhMucVatTuFormValue.ten_danh_muc,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.danhMucVatTuFormValue.ten_danh_muc) = $event)),
                    name: "ten_danh_muc",
                    onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_form_item, {
                prop: "ma_danh_muc",
                class: "mb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "mã danh mục",
                    modelValue: _ctx.danhMucVatTuFormValue.ma_danh_muc,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.danhMucVatTuFormValue.ma_danh_muc) = $event)),
                    disabled: !_ctx.isCreating && _ctx.isMaDanhMucEditable,
                    name: "ma_danh_muc",
                    onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_13,
          _createVNode(_component_TaiKhoanSelection, {
            "label-cols": 2,
            "inputs-cols": 3,
            "ma-tai-khoan-prop": _ctx.taiKhoanData.maTaiKhoan ? parseInt(_ctx.taiKhoanData.maTaiKhoan) : undefined,
            "ma-chi-tiet-prop": _ctx.taiKhoanData.maChiTiet ? _ctx.taiKhoanData.maChiTiet : undefined,
            onOnSelect: _ctx.onSelectTaiKhoan
          }, null, 8, ["ma-tai-khoan-prop", "ma-chi-tiet-prop", "onOnSelect"]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_form_item, {
                prop: "mo_ta",
                class: "mb-0 w-100"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.danhMucVatTuFormValue.mo_ta,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.danhMucVatTuFormValue.mo_ta) = $event)),
                    rows: 3,
                    type: "textarea",
                    placeholder: "Mô tả danh mục vật tư",
                    name: "mo_ta",
                    onFocus: _cache[5] || (_cache[5] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_form_item, {
                prop: "id_cha",
                class: "mb-0 w-100"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.danhMucVatTuFormValue.id_cha,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.danhMucVatTuFormValue.id_cha) = $event)),
                    placeholder: "Danh mục vật tư cha",
                    name: "id_cha"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: 0,
                        label: 'Không có'
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.danhMucChaItems, (c) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: c.id,
                          label: c.ten_danh_muc,
                          value: c.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_ButtonCustom, {
                "button-type": _ctx.ButtonsType.SAVE,
                "color-type": _ctx.ButtonTypeColors.SUCCESS,
                "is-loading": _ctx.isLoading,
                onClick: _ctx.submit
              }, null, 8, ["button-type", "color-type", "is-loading", "onClick"]),
              _createVNode(_component_ButtonCustom, {
                "color-type": _ctx.ButtonTypeColors.DANGER,
                "button-type": _ctx.ButtonsType.TRASH,
                onClick: _ctx.clear
              }, null, 8, ["color-type", "button-type", "onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules", "onSubmit"])
    ])
  ]))
}